import { Flex } from '@pega/cosmos-react-core';
import React from 'react';
import styled, { css } from 'styled-components';

interface ColorPickerProps {
  warningMessage: string;
}

const WarningStyle = styled.div(
  () => css`
    color: #fd6100;
    margin-block-start: 8px;
  `,
);

const ContrastWarning: React.FC<ColorPickerProps> = ({ warningMessage }) => {
  return (
    <Flex role="alert" as={WarningStyle}>
      {warningMessage}
    </Flex>
  );
};

export default ContrastWarning;
